import { Building, Briefcase, HelpCircle } from 'lucide-react';
import { FormField, TextInput, SelectInput, RadioGroup } from '../form-fields';
import { howFoundUsOptions, roleOptions } from '../form-data/formOptions';
import { UserInfoFormData } from '../hooks/useUserInfoForm';

interface Step2ProfileInfoProps {
  formData: UserInfoFormData;
  loading: boolean;
  updateField: (field: keyof UserInfoFormData, value: string) => void;
}

export function Step2ProfileInfo({ formData, loading, updateField }: Step2ProfileInfoProps) {
  const userTypeOptions = [
    { value: 'private', label: 'Private Individual' },
    { value: 'business', label: 'Business/Organization' },
  ];

  return (
    <div className="space-y-4">
      {/* Step Header */}
      <div className="text-center">
        <h2 className="text-lg font-medium text-theme-light-text-primary dark:text-theme-dark-text-primary mb-1">
          Profile Information
        </h2>
        <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary">
          Tell us more about yourself
        </p>
      </div>

      {/* Form Fields */}
      <div className="space-y-4">
        {/* How Found Us Field */}
        <FormField label="How did you find us?" htmlFor="howFoundUs" required>
          <SelectInput
            id="howFoundUs"
            name="howFoundUs"
            placeholder="Select how you found us"
            value={formData.howFoundUs}
            onChange={(e) => updateField('howFoundUs', e.target.value)}
            options={howFoundUsOptions}
            disabled={loading}
            required
            icon={HelpCircle}
          />
        </FormField>

        {/* User Type Field */}
        <FormField label="Account Type" htmlFor="userType" required>
          <RadioGroup
            name="userType"
            value={formData.userType}
            onChange={(value) => updateField('userType', value)}
            options={userTypeOptions}
            disabled={loading}
          />
        </FormField>

        {/* Company Name Field - Only show for business users */}
        {formData.userType === 'business' && (
          <FormField label="Company Name" htmlFor="companyName" required>
            <TextInput
              id="companyName"
              name="companyName"
              placeholder="Enter your company name"
              value={formData.companyName}
              onChange={(e) => updateField('companyName', e.target.value)}
              disabled={loading}
              required
              icon={Building}
            />
          </FormField>
        )}

        {/* Role Description Field */}
        <FormField label="Your Role" htmlFor="roleDescription" required>
          <SelectInput
            id="roleDescription"
            name="roleDescription"
            placeholder="Select your role"
            value={formData.roleDescription}
            onChange={(e) => updateField('roleDescription', e.target.value)}
            options={roleOptions}
            disabled={loading}
            required
            icon={Briefcase}
          />
        </FormField>
      </div>
    </div>
  );
}
